import { axiosClient } from 'AxiosClientProvider'

import type { AllowedIPAddressEditData, AllowedIPAddressResponse } from './types'
import type { UpsertResponse } from '../types'

export const getAllowedIPAddress = async (tenantId: number, workDate?: string): Promise<AllowedIPAddressResponse> => {
  const url = `/tenants/${tenantId}/allowed-ip-address`

  const paramData = workDate ? { 'work-date': workDate } : {}
  const response = await axiosClient.get(url, { params: paramData })
  return response.data
}

export const upsertAllowedIPAddress = async (
  data: AllowedIPAddressEditData,
  tenantId: number
): Promise<UpsertResponse> => {
  const url = `/tenants/${tenantId}/allowed-ip-address`

  const response = await axiosClient.put(url, data)
  return response.data
}
